import BrowserUtil from './BrowserUtil';
import UserStorageUtil from './UserStorageUtil';
/*import HmEventRegistry from './../model/HmEventRegistry';*/

var UserStore = function(){
	var me = this;
	
	var authToken = BrowserUtil.getAuthToken();
	if(authToken === null || authToken.length === 0){
		//console.log("Clear storage triggered");
		UserStorageUtil.clearSessionStorage();
	}

	var isUserAvailable = function(){
		try{
			if(!me.user){
				me.user = me.get();
			}

			if(me.user && me.user.userId && me.user.userId.length > 0){
				return true;
			}else{
				me.clearOldUser();
				return false;
			}
			
		}catch(e){
			me.clearOldUser();
			//HmEventRegistry.fireEvent("LOG_OUT_PROMPT");
			return false;
		}

	}

	this.clearOldUser = function(){
		UserStorageUtil.clearSessionStorage();
	}

	this.store = function(user){
		this.user = user;
		UserStorageUtil.storeSessionItem("USER_DETAILS",user);
		BrowserUtil.setUserDetails(user);
	}

	this.set = this.store;

	this.get = function(){
		BrowserUtil.setUserDetails(UserStorageUtil.getStoredSessionItem("USER_DETAILS"));
		this.user = BrowserUtil.getUserDetails();
		return BrowserUtil.getUserDetails();
	}

	this.getUserId = function(){
		if(isUserAvailable()){
			return this.user.userId;
		}else{
			return "";
		}
	}

	this.getUserName = function(){
		if(isUserAvailable()){
			return this.user.userName;
		}else{
			return "";	 		
		}
	}

	this.getLoginId = function(){
		if(isUserAvailable()){
			return this.user.loginId;
		}else{
			return "";
		}
	}

	this.getRole = function(){
		if(isUserAvailable()){
			return this.user.userRole.role;
		}else{
			return "";
		}
	}

	this.getDob = function(){
		if(isUserAvailable()){
			return this.user.dob;
		}else{
			return "";
		}
	}

	this.getGender = function(){
		if(isUserAvailable()){
			return this.user.gender;
		}else{
			return "";
		}
	}

	this.getEmail = function(){
		if(isUserAvailable()){
			return this.user.email;
		}else{
			return "";
		}
	}
	
	this.getMobile = function(){
		if(isUserAvailable()){
			return this.user.phone;
		}else{
			return "";
		}
	}
	
	this.getModeID= function(){
		if(isUserAvailable()){
			return this.user.modeId;
		}else{
			return "";
		}
	}

	this.getLanguage = function(){
		if(isUserAvailable()){
			return this.user.language;
		}else{
			return "";
		}
	}

	this.getLocale = this.getLanguage;
	
	this.isSimulation = function(){
		if(isUserAvailable()){
			return this.user.simulation;
		}else{
			return "";
		}

	}

	this.getAuthToken = function(){
		if(isUserAvailable()){
			return this.user.authToken;
		}else{
			return "";
		}

	}

	this.getUserAgent = function(){
		if(isUserAvailable()){
			return this.user.userAgent;
		}else{
			return "";
		}
	}

	this.getDevice = function(){
		if(isUserAvailable()){
			return this.user.device;
		}else{
			return "";
		}
	}

	this.getIpAddress = function(){
		if(isUserAvailable()){
			return this.user.ipAddress;
		}else{
			return "";
		}
	}

	this.getPermissions = function(){
		if(isUserAvailable()){
			return this.user.permission;
		}else{
			return {};
		}
	}

	this.getAccessMap = function(){
		if(isUserAvailable()){
			return this.user.access;
		}else{
			return {};
		}
	}

	this.getReverseAccessMap = function(){
		if(isUserAvailable()){
			let reverseMap = {};
			try{
				if(this.user.access){
					for(let i in this.user.access){
						reverseMap[this.user.access[i]] = i;
					}
				}
			}catch(e){}

			return reverseMap;
		}else{
			return {};
		}
	}
	
	this.getEntlHistory = function(){
		if(isUserAvailable()){
			return this.user.entlHistory;
		}else{
			return {};
		}
	}
	
	this.getAuthProviderId = function(){
		if(isUserAvailable()){
			return this.user.authProviderId;
		}else{
			return 0;
		}
	}
	

	this.isAllowed = function(key){
		if(isUserAvailable()){
			try{
				if(key !== undefined && key !== null && key.length > 0){
					var perm = this.getPermissions();

					if(perm[key] !== undefined && perm[key] !== null && perm[key].length > 0){
						return true;
					}
				}
			}catch(e){}

			return false;
		}else{
			return false;
		}
	}

	this.allowedLevels = function(key){
		if(isUserAvailable()){
			if(key !== undefined && key !== null && key.length > 0){
				try{
					var perm = this.getPermissions();
					
					if(perm[key] !== undefined && perm[key] !== null && perm[key].length > 0){
						return perm[key].split(",");
					}
				}catch(e){}

			}else{
				console.error("key is required for allowedLevels.");
			}
		}
		return [];

	}

	this.getAttribute = function(attrKey){
		if(isUserAvailable()){
			if(attrKey && this.user.userAttributes){
				return this.user.userAttributes[attrKey] || null;
			}
		}

		return null;
	}

	this.getSchoolInfo = function(){
		if(isUserAvailable()){
			return this.user.school;	
		}

		return null;
	}

	this.getSchoolId = function(){
		if(isUserAvailable()){
			if(this.user.school && !isNaN(this.user.school.schoolId)){
				return Number(this.user.school.schoolId);
			}
		}

		return 0;
	}

	this.getSchoolName = function(){
		if(isUserAvailable()){
			if(this.user.school && this.user.school.schoolName){
				return this.user.school.schoolName;
			}
		}

		return null;
	}

	this.getSchoolBoard = function(){
		if(isUserAvailable()){
			if(this.user.school && this.user.school.board){
				return this.user.school.board;
			}
		}

		return null;
	}

	this.getSchoolPrefix = function(){
		if(isUserAvailable()){
			if(this.user.school && this.user.school.prefix){
				return this.user.school.prefix;
			}
		}

		return null;
	}

	this.isHmUser = function(){
		if(isUserAvailable()){
			if(this.user.heymathUser){
				return this.user.heymathUser;
			}
		}

		return false;
	}

	this.getUserOrigin = function(){
		if(isUserAvailable()){
			if(this.user.origin){
				return this.user.origin;
			}
		}

		return "default";
	}

	this.isPilotUser = function(){
		if(isUserAvailable()){
			if(this.user.pilotUser){
				return this.user.pilotUser;
			}
		}

		return false;
	}

	this.getGeo = function(){
		if(isUserAvailable()){
			if(this.user.countryCode){
				return this.user.countryCode;
			}
		}

		return "";		
	}


	this.user = (!this.user) ? this.get() : this.user;
}

export default UserStore;


// WEBPACK FOOTER //
// ./src/util/UserStore.js